import React, { FC, useCallback, useEffect, useState } from 'react';
import {  apiGetTopJourneysInsights } from 'src/utils/journeyApi';
import { FixedLoadingSpinner } from 'src/common/components/loading-spinner';
import {
  TimePeriodKey,
  TimePeriodOption,
} from 'src/dashboard/insights/constants';
import { DashboardInsightsItemLayout } from 'src/dashboard/insights/home/item-layout';
import { DashboardInsightsJourneysJourneyContent } from 'src/dashboard/insights/home/content';
import useDashboardActiveTab from 'src/dashboard/helpers/active-tab.hook';
import { createTimePeriodOptionAllTime, createTimePeriodOptionLast30Days } from 'src/dashboard/insights/helpers/time-periods';
import { Helmet } from 'react-helmet';
// import JoyRideOnboardingGuide from 'src/onboarding/joyride-onboarding'
import { buildInsightsViewDetails } from '../insights/helpers';
import { useDepsMatchingCallbackRef } from 'src/utils/react/deps-matching-callback-ref.hook';
import { useCurrentUser } from 'src/store/user';

const TIME_PERIODS: TimePeriodOption[] = [createTimePeriodOptionLast30Days(), createTimePeriodOptionAllTime()];

export const HomeDashboardTab = () => {

  useDashboardActiveTab('home');
  const  activeTabType = 'visitor-sessions'
  const [journeyIds, setJourneyIds] = useState()

  const [domLoaded, setDomLoaded] = useState(false);
  const [topInsights, setTopInsights] = useState<any[]>([]); // State to store top 5 insights
  const [fetchingTopInsights, setFetchingTopInsights] = useState(true)

  const { currentUser } = useCurrentUser();

  const [timePeriodKey, setTimePeriodKey] = useState<TimePeriodKey>('all_time');
  const timePeriodOption = TIME_PERIODS.find((tp) => tp.key === timePeriodKey);

  const onFetchJourneyInsightsRef = useDepsMatchingCallbackRef(
    (response: any) => {
      setTopInsights(response.views.map(buildInsightsViewDetails));
      setJourneyIds(response.journey_ids)
    },
    []
  );

  const fetchTopInsights = useCallback(async (orgId) => {
    try {
      setFetchingTopInsights(true);
      const response = await apiGetTopJourneysInsights(orgId);
      onFetchJourneyInsightsRef.current && onFetchJourneyInsightsRef.current(response, []);
      return response;
    } catch (error) {
      console.error('Failed to fetch top 5 insights', error);
    }
    finally{
      setFetchingTopInsights(false);
    }
  }, []);


  useEffect(() => {

    const handler = setTimeout(() => {
      setDomLoaded(true);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };

  }, []);

  useEffect(() => {
    if(currentUser){
      fetchTopInsights(currentUser.last_organization.id);
    }
  }, [fetchTopInsights,currentUser]);

  // const loading = fetchingMetrics || fetchingEngagements || fetchingTopInsights;
  const loading =  fetchingTopInsights;

    if (loading) {
      return <FixedLoadingSpinner />;
    }
 
  const headerSection = topInsights ? (
    <div className='flex gap-6 w-full justify-between'>
      <h1 className='text-bedrock-serif-h1 line-clamp-1'>Here's how prospects are interacting with your Journeys</h1>
    
    </div>
  ) : null;

  const contentSection = !loading ? 
  (topInsights? ( 
    topInsights.length>0?
    <DashboardInsightsJourneysJourneyContent
      activeTabType={activeTabType}
      timePeriodParam={timePeriodOption?.param}
      insights={topInsights}
    />
    :
    <div className='text-bedrock-p'>No visitors found yet</div>
  ) : null ): null;

  return (
    <>
      <Helmet>
        <title>Journey | Home Dashboard</title>
      </Helmet>

      {/* { domLoaded && <JoyRideOnboardingGuide initial={false}/> } */}

      <DashboardInsightsItemLayout
        headerSection={headerSection}
        contentSection={contentSection}
      />

    </>
  );
};